"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var setClauseValue_1 = require("../setClauseValue");
var legacy_1 = require("satcheljs/lib/legacy");
var datapoints_1 = require("../datapoints");
/**
 * Adds a phrase to a 'contains words' clause value
 * @param clauseId the id of the clause to add the phrase to
 * @param phraseToAdd the phrase to add the the clause value
 * @param actionSource the source of the action (onBlur, keyboard)
 */
exports.default = legacy_1.action('addPhraseToClause', datapoints_1.default.addPhraseToClauseDatapoint)(function addPhraseToClause(clauseId, phraseToAdd, actionSource) {
    var existingPhrases = store_1.default.inboxRulesEditState.clauseMap.get(clauseId)
        .clauseValue;
    if (!existingPhrases) {
        existingPhrases = [];
    }
    // only add unique, non-empty phrases
    if (existingPhrases.indexOf(phraseToAdd) == -1) {
        existingPhrases.push(phraseToAdd);
        setClauseValue_1.default(existingPhrases, clauseId);
        // clear the input field if the phrase was added
        store_1.default.inboxRulesEditState.includesWordsInputTextMap.set(clauseId, '');
    }
});
//# sourceMappingURL=addPhraseToClause.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/addPhraseToClause.js
// module id = 5193
// module chunks = 2